import { render, staticRenderFns } from "./PagedListLanguages.vue?vue&type=template&id=332e81a8&"
import script from "./PagedListLanguages.vue?vue&type=script&lang=js&"
export * from "./PagedListLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports